export const GET_OFFER_FOR_ADMIN_PANEL = "GET_OFFER_FOR_ADMIN_PANEL"
export const GET_OFFER_FOR_FRONT_PANEL = "GET_OFFER_FOR_FRONT_PANEL"
